import { useRecordCbtMonitoringConsentMutation } from '@/types/vue-apollo-helpers';

export function useRecordConsent() {
  const { mutate, loading, error } = useRecordCbtMonitoringConsentMutation();

  const record = async(cbtTestSessionId: string): Promise<{ id: string; accepted_at: string }> => {
    const result = await mutate({ cbt_test_session_id: cbtTestSessionId });
    const consent = result?.data?.recordCbtMonitoringConsent;
    if (!consent) throw new Error('Failed to record monitoring consent');
    return consent;
  };

  return { record, loading, error };
}
